<template>
  <section class="section">
    <div class="is-title-bar">
      <div class="level">
        <div class="level-left">
          <div class="level-item">
            <h1 class="title">Alerta</h1>
          </div>
          <!-- <h3 style="color:#888888" class="subtitle">{{ getClientName() }}</h3> -->
        </div>
      </div>
    </div>
    <div class="card has-table">
      <div class="card-header"></div>

      <b-table
        :data="desserts"
        :paginated="true"
        :pagination-simple="true"
        :per-page="perPage"
        striped
        v-if="renderComponent"
      >
        <template slot-scope="props" v-if="getAPname(props.row)">
          <b-table-column
            class="is-uppercase"
            field="ip"
            label="Vagalume"
            sortable
            >{{ getAPname(props.row) }}
          </b-table-column>

          <b-table-column class="is-uppercase" field="ip" label="IP" sortable
            >{{ props.row.ip }}
          </b-table-column>

          <!-- <b-table-column
            class="is-uppercase"
            field="total"
            label="Total"
            sortable
          >Total: {{ total(props.row) }}
          </b-table-column> -->

          <b-table-column label="Limiar" field="sensor_limit" sortable>
            {{ props.row.sensor_limit }}
          </b-table-column>

          <b-table-column label="Maturação" field="step_up" sortable>
            {{
              11 > props.row.step_up
                ? "Lenta"
                : props.row.step_up > 49
                ? "Rápida"
                : "Regular"
            }}
          </b-table-column>

          <b-table-column label="Dematuração" field="step_down" sortable>
            {{
              11 > props.row.step_down
                ? "Lenta"
                : props.row.step_down > 49
                ? "Rápida"
                : "Regular"
            }}
          </b-table-column>

          <b-table-column label="Status" field="sensor_step_score" sortable>
            {{
              props.row.sensor_step_score > 100
                ? 100
                : props.row.sensor_step_score
            }}%
          </b-table-column>

          <b-table-column
            field="datetime_last_sensor"
            label="Último caso detectado"
            sortable
            date
          >
            {{
              props.row.datetime_last_sensor
                ? new Date(props.row.datetime_last_sensor).toLocaleString(
                    "pt-BR",
                    {
                      year: "numeric",
                      month: "numeric",
                      day: "numeric",
                      hour: "numeric",
                      minute: "numeric",
                      timeZone: "UTC"
                    }
                  )
                : "Sem ocorrências"
            }}
          </b-table-column>

          <b-table-column label="Alarme" field="sensor_step_score" sortable>
            <span
              :class="[
                'tag',
                props.row.sensor_step_score > 90 ? 'is-danger' : ''
              ]"
              >{{ props.row.sensor_step_score > 90 ? "Aglomeração" : "" }}</span
            >
          </b-table-column>

          <b-table-column label="Ativo" field="sensor_alarm" sortable>
            <b-icon
              :icon="props.row.sensor_alarm ? 'check-circle' : 'times-circle'"
              :type="props.row.sensor_alarm ? 'is-success' : 'is-danger'"
            ></b-icon>
          </b-table-column>

          <b-table-column field="actions" numeric label="">
            <b-button
              icon-right="edit"
              size="is-small"
              type="is-info"
              @click="editItem(props.row)"
              >Editar</b-button
            >
          </b-table-column>

          <!-- numeric para alinhar as acoes a direita-->
          <!-- <b-table-column
          field="actions"
          numeric
          label="">
            <b-button
              icon-right="edit"
              size="is-small"
              type="is-info"
              @click="editItem(props.row)"
            >Editar</b-button>
            <b-button
              icon-right="poll-h"
              size="is-small"
              type="is-success"
              @click="openData(props.row)"
            >Resultado</b-button>
            <b-button
              icon-right="trash"
              size="is-small"
              type="is-danger"
              @click="deleteItem(props.row)"
            >Excluir</b-button>
          </b-table-column>
          <b-modal has-modal-card trap-focus can-cancel :active.sync="dataMidia">
            <div class="modal-card">
              <div class="modal-card-body">
                <pyramid-chart
                  :legend="true"
                  :chart-data="pyramidData"
                  :titulo="pyramidTitle"
                  :tickRange="pyramidTick"
                  name="teste"
                ></pyramid-chart>
              </div>
            </div>
          </b-modal> -->
        </template>
        <template slot="empty">
          <section class="section">
            <div class="has-text-grey has-text-centered">
              <span>Sem regras para exibir</span>
            </div>
          </section>
        </template>
        <template slot="footer">
          <div class="level" style="padding-bottom: 0">
            <div class="level-left"></div>
            <div class="left-center"></div>
            <div class="level-right">
              <b-select v-model="perPage" size="is-small">
                <option value="10">10 por página</option>
                <option value="25">25 por página</option>
                <option value="50">50 por página</option>
                <option value="100">100 por página</option>
              </b-select>
            </div>
          </div>
        </template>
      </b-table>
    </div>
    <b-modal
      :active.sync="dialog"
      has-modal-card
      trap-focus
      :can-cancel="false"
      aria-role="dialog"
      aria-modal
    >
      <form action>
        <div class="modal-card" style="width: auto">
          <header class="modal-card-head">
            <p class="modal-card-title">Gerenciar Regra</p>
          </header>
          <section class="modal-card-body">
            <div class="columns">
              <div class="column">
                <b-field label="Vagalume">
                  <!--
                  <b-input v-model="editedItem.ip">{{getAPname(editedItem.ip)}}</b-input>
                  -->

                  <b-select
                    placeholder="Vagalume"
                    v-model="editedItem.ip"
                    expanded
                    disabled
                  >
                    <option
                      v-for="option in vagaAPs"
                      :value="option.ip"
                      :key="option.ip"
                    >
                      {{
                        option.name.split("--")[1] == null
                          ? option.name.split("_")[1]
                          : option.name.split("--")[1]
                      }}
                    </option>
                  </b-select>
                </b-field>

                <b-field
                  :label="editedItem.ip"
                  label-position="inside"
                ></b-field>
                <br />
                <b-field label="Limiar">
                  <b-numberinput
                    placeholder="Limiar"
                    step="5"
                    min="40"
                    max="120"
                    v-model="editedItem.sensor_limit"
                  >
                  </b-numberinput>
                </b-field>

                <b-field label="Maturação" label-position="on-border">
                  <b-select
                    placeholder="Maturação"
                    v-model="editedItem.step_up"
                    expanded
                  >
                    <option
                      v-for="option in [
                        { level: 'Lenta', step: '10' },
                        { level: 'Regular', step: '30' },
                        { level: 'Rápida', step: '50' }
                      ]"
                      :value="option.step"
                      :key="option.step"
                      >{{ option.level }}</option
                    >
                  </b-select>
                </b-field>
                <b-field label="Dematuração" label-position="on-border">
                  <b-select
                    placeholder="Dematuração"
                    v-model="editedItem.step_down"
                    expanded
                  >
                    <option
                      v-for="option in [
                        { level: 'Lenta', step: '10' },
                        { level: 'Regular', step: '30' },
                        { level: 'Rápida', step: '50' }
                      ]"
                      :value="option.step"
                      :key="option.step"
                      >{{ option.level }}</option
                    >
                  </b-select>
                </b-field>

                <br />
                <b-field>
                  <b-checkbox
                    type="is-primary"
                    v-model="editedItem.sensor_alarm"
                    >Ativo</b-checkbox
                  >
                </b-field>
              </div>
            </div>
          </section>
          <footer class="modal-card-foot">
            <b-button @click="close" :loading="saving">Cancelar</b-button>
            <b-button
              type="is-primary"
              @click.native="save"
              :loading="saving"
              :disabled="editedIndex === -1"
              >Salvar</b-button
            >
            <b-button
              type="is-primary"
              :disabled="editedIndex === -1"
              @click.native="saveForAll"
              :loading="saving"
              >Aplicar a todos</b-button
            >
          </footer>
        </div>
      </form>
    </b-modal>
  </section>
</template>

<script>
import Webservices from "@/Webservices";
import Pie from "@/components/charts/Pie";
import Bar from "@/components/charts/Bar";
import Linechart from "@/components/charts/Linechart";
import OnlineLine from "@/components/charts/OnlineLine";
import BoxStat from "@/components/charts/BoxStat";
import HorizontalBar from "@/components/charts/HorizontalBar.vue";
import PyramidChart from "@/components/charts/PyramidChart.vue";
import ChartMin from "@/components/charts/ChartMin.vue";
import store from "@/store";
import { mapActions, mapGetters } from "vuex";

const ws = new Webservices();

export default {
  components: {
    Pie,
    Bar,
    BoxStat,
    Linechart,
    PyramidChart
  },
  name: "Videos",
  data: () => ({
    renderComponent: true,
    dataMidia: false,
    saving: false,
    perPage: 50,
    fileObj: undefined,
    weekdays: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"],

    qtAdd: undefined,
    questions: [],
    questionsDistinct: [],
    selectedVagaAP: {},
    videoUploaded: false,
    dateSD: "",
    dateED: "",
    modalSD: false,
    modalED: false,
    loading3: false,
    modal: false,
    imageName: "",
    imageUrl: "",
    imageFile: "",
    dialog: false,
    startHour: "00:00",
    endHour: "23:59",
    desserts: [],
    vagaAPs: [],
    editedIndex: -1,
    editedItem: {
      controller_id: "",
      ip: "",
      connect_limit: 60,
      sensor_limit: 60,
      connect_alarm: false,
      sensor_alarm: true,
      step_up: 30,
      step_down: 10,
      sensor_step_score: 0,
      connect_step_score: 0,
      datetime_last_connect: null,
      datetime_last_sensor: null,
      id: ""
    },
    defaultItem: {
      controller_id: "",
      ip: "",
      connect_limit: 60,
      sensor_limit: 60,
      connect_alarm: false,
      sensor_alarm: true,
      step_up: 30,
      step_down: 10,
      sensor_step_score: 0,
      connect_step_score: 0,
      datetime_last_connect: null,
      datetime_last_sensor: null
    }
  }),
  computed: {
    ...mapGetters([
      "ageRanges",
      "getClientID",
      "getControllerId",
      "getName",
      "getID",
      "getRules",
      "isADM",
      "getGroupId",
      "getClients",
      "getToken",
      "getRadioPrefix"
    ]),
    formTitle() {
      return this.editedIndex === -1 ? "Nova Mídia" : "Editar";
    },
    isImage() {
      return /[^/]+(jpeg|jpg|png|gif)$/.test(this.imageName);
    },
    getActiveFields() {
      return this.client_fields.filter(el => el.is_active);
    }
  },

  mounted() {
    ws.setToken(this.getToken);
    /** NOVO */
    //document.addEventListener("openMidia", evt => {
    //this.daySelected = evt.detail;
    //this.loadDayData(evt.detail);
    //});
    if (this.getID) {
      ws.getNotifications(this.getControllerId).then(response => {
        this.desserts = response.data.map(el => ({
          ...el
        }));
      });
      // ws.getNotificationConfigs(this.getClientID).then(response => {
      //   this.desserts = response.data.map(el => ({
      //     ...el
      //   }));

      // });
    }
    ws.getRadiosByRadioPrefix(this.getRadioPrefix)
      .then(res => {
        this.vagaAPs = res.data;
      })
      .catch(err => {
        console.log(err);
      });
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    getControllerId(newValue) {
      this.client_fields = [];
      this.desserts = [];
      this.configs = [];

      ws.getNotifications(this.getControllerId).then(response => {
        this.desserts = response.data.map(el => ({
          ...el
        }));
      });
      // ws.getNotificationConfigs(this.getClientID).then(response => {
      //   this.desserts = response.data.map(el => ({
      //     ...el
      //   }));

      // });
      ws.getRadiosByRadioPrefix(this.getRadioPrefix)
        .then(res => {
          this.vagaAPs = res.data;
        })
        .catch(err => {
          console.log(err);
        });
    }
  },

  /** TODO
   * Pegar informações de configuração,
   * adicionar a modal,
   * possibilitar alteração nas configurações,
   * e criar modificações individuais pros radios
   *
   */
  created() {
    this.initialize();
  },

  methods: {
    initialize() {},

    async saveForAll() {
      this.saving = true;

      var dessert_len = this.desserts.length;
      for (var i = 0; i < dessert_len; i++) {
        const el = this.desserts[i];

        var item = Object.assign({}, this.editedItem);

        item["ip"] = el.ip;
        item["datetime_last_sensor"] = el.datetime_last_sensor;
        item["sensor_step_score"] = el.sensor_step_score;
        item["id"] = el.id;

        var response = await ws.updateNotificationRule(item);

        if (!this.getID && i == 0) this.desserts.push(response.data);
        else if (response.data.id == el.id) this.desserts.push(response.data);
      }
      this.desserts = this.desserts.slice(dessert_len, dessert_len * 2);
      this.saving = false;

      this.close();
    },
    getClientName() {
      return store.state.client.name;
    },
    dateConverter(date) {
      return date.toLocaleString("pt-BR", {
        year: "numeric",
        month: "numeric",
        day: "numeric",
        timeZone: "UTC"
      });
    },

    getAPname(rule) {
      var apName = this.vagaAPs.find(x => x.ip === rule.ip);
      return apName
        ? apName.name.split("--")[1] == null
          ? apName.name.split("_")[1]
          : apName.name.split("--")[1]
        : "";
    },

    deleteItem(item) {
      const index = this.desserts.indexOf(item);
      if (confirm("Você tem certeza que deseja remover essa regra?")) {
        this.desserts.splice(index, 1);
        ws.deleteVideoManifest(item.id).then(response => {});
      }
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.renderComponent = true;
        //this.resetForm();
      }, 300);
    },

    save() {
      this.saving = true;
      this.editedItem["controller_id"] = this.getControllerId;

      this.renderComponent = false;
      if (this.editedIndex > -1) {
        ws.updateNotificationRule(this.editedItem).then(response => {
          this.desserts[this.editedIndex] = response.data;
          this.renderComponent = true;
          //this.initialize()
          //this.resetForm();
        });
      } else {
        ws.saveNewNotificationRule(this.editedItem).then(response => {
          this.desserts.push(response.data);
          this.renderComponent = true;
        });
      }
      this.close();

      this.saving = false;
    },

    resetForm() {
      this.imageName = "";
      this.fileObj = undefined;
      this.loading3 = false;
      this.dateSD = "";
      this.dateED = "";
      this.videoUploaded = false;
    },

    removeItem(item) {
      this.editedItem.targetQuestions.splice(
        this.editedItem.targetQuestions.indexOf(item),
        1
      );
      this.$forceUpdate();
    },

    addRule() {
      this.dialog = true;
      this.editedItem = JSON.parse(JSON.stringify(this.defaultItem));
      this.editedIndex = -1;
    },
    editItem(item, event) {
      Object.assign(this.editedItem, item);
      //this.editedItem = item;
      this.editedIndex = this.desserts.indexOf(item);

      this.dialog = true;
    }
  }
};
</script>

<style scoped>
.capitalize {
  text-transform: capitalize !important;
}
.preview {
  position: relative;
  width: 160px;
  padding: 0;
  border: thin solid blue;
  background-color: lightgray;
  z-index: 1;
  overflow-y: hidden;
}

.toolbar-phone {
  position: absolute;
  width: 160px;
  top: 0;
  left: 0;
  border: thin solid blue;
  background-color: whitesmoke;
  z-index: 3;
  opacity: 0.88;
}

.viewport-phone {
  position: absolute;
  width: 160px;
  left: 0;
  background-color: lightgray;
  z-index: 2;
}
</style>



// WEBPACK FOOTER //
// src/components/Notifications.vue